import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ELearningService } from 'src/app/modules/e-learning/e-learning.service';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CourseGuard implements CanActivate {
  role: string;
  token: string;
  courseEnd: any;
  today = new Date();

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _elearningService: ELearningService,
  ) {
    this.token = this._authService.getToken();
  }

  canActivate() {
    let courseId = window.location.pathname.split("/")[2];
    let _today = new Date(this.today).getTime();

    if (courseId) {
      return this._authService.getRole().pipe(
        switchMap(r => {
          this.role = r.result.ROLE;

          return this._elearningService.getDetailCourseById(courseId).pipe(
            map(c => {
              this.courseEnd = new Date(c.result[0].COURSE_END).getTime();

              if (this.role === 'user' && this.courseEnd !== 0) {
                if (_today >= this.courseEnd) {
                  this._router.navigate(['/']);
                  return false;
                } else {
                  return true;
                }

              } else {
                return true;
              }

            })
          )
        }),
        catchError(() => {
          this._router.navigate(['/']);
          return of(false);
        })
      )
    } else {
      return true;
    }

  }

}
